import React from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

import saLogo from "../assests/SALOGO.png";

const menuItems = [
  {
    name: "Home",
    href: "/",
  },
  // {
  //   name: "About",
  //   href: "/about",
  // },


  {
    name: "Product",
    href: "/product",
  },
  {
    name: "Live Courses",
    href: "/#live-courses",
  },
  {
    name: "Free Courses",
    href: "/free-courses",
  },
  {
    name: "Pro Courses",
    href: "/pro-courses",
  },
  {
    name: "Course Bundles",
    href: "/course-bundles",
  },
  {
    name: "Become An Affiliate",
    href: "/affiliate",
  },
];

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="sticky top-0 z-[5] w-full bg-white pb-10">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-2 sm:px-6 lg:px-8">
        <div className="inline-flex items-center space-x-2">
          <span>
            <img src={saLogo} alt="Logo" className="w-16" />
          </span>
        </div>
        <div className="hidden lg:block">
          <ul className="inline-flex space-x-8">
            {menuItems.map((item) =>
              item.name == "Become An Affiliate" ? (
                <li key={item.name} className="relative">
                  <a
                    href={item.href}
                    className="text-sm font-semibold text-gray-800 hover:text-gray-900"
                  >
                    {item.name}{" "}
                    <span className="bg-green-300 text-[10px] p-[3px] font-bold rounded relative -top-3 right-1">
                      Trending &#x1F525;
                    </span>
                  </a>
                </li>
              ) : (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="text-sm font-semibold text-gray-800 hover:text-gray-900"
                  >
                    {item.name}
                  </a>
                </li>
              )
            )}
          </ul>
        </div>

        <div className="hidden lg:flex gap-5">
          <Link
            to={"https://courses.successanalytics.in/s/dashboard"}
            target="_blank"
          >
            <button
              type="button"
              className="rounded-md bg-[#001732] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
            >
              Member Portal
            </button>
          </Link>
        </div>
        <div className="lg:hidden">
          <Menu onClick={toggleMenu} className="h-6 w-6 cursor-pointer" />
        </div>
        {isMenuOpen && (
          <div className="absolute inset-x-0 top-0 z-50 origin-top-right transform p-2 transition lg:hidden">
            <div className="divide-y-2 divide-gray-50 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
              <div className="px-5 pb-6 pt-5">
                <div className="flex items-center justify-between">
                  <div className="inline-flex items-center space-x-2">
                    <span>
                      <img src={saLogo} alt="Logo" className="w-16" />
                    </span>
                  </div>
                  <div className="-mr-2">
                    <button
                      type="button"
                      onClick={toggleMenu}
                      className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                    >
                      <span className="sr-only">Close menu</span>
                      <X className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                <div className="mt-6">
                  <nav className="grid gap-y-4">
                    {menuItems.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="-m-3 flex items-center rounded-md p-3 text-sm font-semibold hover:bg-gray-50"
                      >
                        <span className="ml-3 text-base font-medium text-gray-900">
                          {item.name}
                        </span>
                      </a>
                    ))}
                  </nav>
                </div>

                <div>
                  <Link
                    to={"https://courses.successanalytics.in/s/dashboard"}
                    target="_blank"
                  >
                    <button
                      type="button"
                      className="w-full rounded-md bg-[#001732] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                    >
                      Member Portal
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
